<!-- src/views/Login.vue -->
<template>
  <div class="login-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card login-form mx-auto">
            <div class="card-body p-4 p-md-5">
              <div class="text-center mb-5">
    <img src="@/assets/logo1.jpeg" alt="Katherine Luzuriaga Ortodoncia" class="login-logo mb-3" />
                <p class="text-muted">Inicia sesión para acceder al sistema</p>
              </div>

              <!-- Alert for errors -->
              <div v-if="error" class="alert alert-danger mb-4">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ error }}
              </div>

              <form @submit.prevent="login">
                <div class="mb-3">
                  <label for="username" class="form-label">Usuario</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person"></i></span>
                    <input type="text" class="form-control" id="username" placeholder="Nombre de usuario"
                      v-model="credentials.username" required autofocus />
                  </div>
                </div>

                <div class="mb-4">
                  <label for="password" class="form-label">Contraseña</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-lock"></i></span>
                    <input :type="showPassword ? 'text' : 'password'" class="form-control" id="password"
                      placeholder="Contraseña" v-model="credentials.password" required />
                    <button class="btn btn-outline-secondary" type="button" @click="togglePasswordVisibility">
                      <i :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                    </button>
                  </div>
                </div>

                <div class="d-grid">
                  <button class="btn btn-primary btn-lg" type="submit" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    Iniciar sesión
                  </button>
                </div>
              </form>

              <div class="text-center mt-4">
                <p class="mb-0 text-muted">
                  ¿Olvidaste tu contraseña? Contacta al administrador del sistema.
                </p>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="text-center mt-4">
            <p class="mb-0 text-muted">
              © {{ new Date().getFullYear() }} Katherine Luzuriaga Ortodoncista. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/api';
import BrandLogo from '@/components/layout/BrandLogo.vue';

export default {
  name: 'Login',
  components: {
    BrandLogo
  },
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loading: false,
      error: null,
      showPassword: false
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = null;

      try {
        const response = await authService.login(this.credentials);
        
        // Token storage is now handled in the authService login method

        // Redirect to original requested page or dashboard
        const redirectPath = this.$route.query.redirect || '/';
        this.$router.push(redirectPath);
      } catch (error) {
        console.error('Login error:', error);

        // Handle different error scenarios
        if (error.response) {
          if (error.response.status === 401) {
            this.error = 'Usuario o contraseña incorrectos. Por favor, inténtalo de nuevo.';
          } else {
            this.error = 'Error en el servidor. Por favor, inténtalo más tarde.';
          }
        } else if (error.request) {
          this.error = 'No se pudo conectar con el servidor. Comprueba tu conexión a internet.';
        } else {
          this.error = 'Error al iniciar sesión. Por favor, inténtalo de nuevo.';
        }
      } finally {
        this.loading = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style scoped lang="scss">

/* Main color scheme based on logo */
:root {
  --primary: #1d5a5a;
  --primary-light: #2a8080;
  --primary-dark: #143e3e;
  --primary-transparent: rgba(29, 90, 90, 0.1);
  
  --bs-primary: var(--primary);
  --bs-primary-rgb: 29, 90, 90;
  --bs-link-color: var(--primary);
  --bs-link-hover-color: var(--primary-dark);
}
.login-logo {
  width: 280px; /* Increase size */
  max-width: 80%;
  margin: 0 auto 20px;
  display: block;
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background-color: #f5f7fa;
}

.login-form {
  max-width: 450px;
  width: 100%;
}

.btn-primary {
  background-color: #1d5a5a !important;
  border-color: #1d5a5a !important;
}

.btn-primary:hover, 
.btn-primary:focus {
  background-color: #143e3e !important;
  border-color: #143e3e !important;
}
</style>